module.exports = __webpack_public_path__ + "img/29f0c8c.png";